import { TextSelection } from 'prosemirror-state'
export function validateCustomListMultipleParagraphs(tr, schema) {
  const { to, from, anchor, head } = tr.selection

  const fromIsAnchor = from === anchor
  const fromIsHead = from === head

  let newTo = to
  let newFrom = from

  const listItemsToFix = []

  tr.doc.descendants((child, pos) => {
    if (child.type.name === 'customListItem' && child.content.childCount > 1) {
      listItemsToFix.push({
        pos,
        child,
      })
    }
    return false
  })
  if (listItemsToFix.length === 0) {
    return false
  }
  for (let i = listItemsToFix.length - 1; i >= 0; i--) {
    const listItem = listItemsToFix[i]
    const { pos, child } = listItem

    const resultArray = []

    let childPos = pos + 1
    for (let j = 0; j < child.content.childCount; j++) {
      const childNode = child.content.child(j)

      if (childNode.type.name === 'paragraph') {
        // If it's a paragraph, we need to wrap it in a list item

        const wrappingListItem = schema.nodes.customListItem.create(
          {
            depth: child.attrs.depth,
            'list-style-type': child.attrs['list-style-type'],
            'item-number': child.attrs['item-number'], // Doesn't matter
            'list-id': child.attrs['list-id'],
          },
          [childNode],
        )
        resultArray.push(wrappingListItem)

        const childStartsEntirelyBeforeSelection =
          childPos + childNode.nodeSize <= from
        const childStartsEntirelyAfterSelection = childPos >= to
        const childStartsAndEndsEntirelyWithinSelection =
          childPos >= from && childPos + childNode.nodeSize <= to
        if (childStartsEntirelyAfterSelection) {
          // do nothing
        } else if (childStartsEntirelyBeforeSelection) {
          // If the child starts entirely before the selection, then converting
          // it to a list item will mean adding 2 to the selection
          newTo += 2
          newFrom += 2
        } else if (childStartsAndEndsEntirelyWithinSelection) {
          // If the child starts and ends entirely within the selection, then
          // converting it to a list item will mean adding 1 to the selection
          newTo += 1
        } else if (childPos < to) {
          // If the child starts before the selection, but ends after it, then
          // we need to adjust the selection
          newTo += 1
        } else if (childPos < from) {
          newFrom++
        }
      } else {
        // Otherwise we need to simply add the node after the list item
        resultArray.push(childNode)
      }

      childPos += childNode.nodeSize
    }

    console.warn('Replacing with', resultArray)
    tr.replaceWith(pos, pos + child.nodeSize, resultArray)
  }

  tr.setSelection(
    TextSelection.create(
      tr.doc,
      fromIsAnchor ? newFrom : newTo,
      fromIsHead ? newTo : newFrom,
    ),
  )

  return true
}
